// extracted by mini-css-extract-plugin
module.exports = {"pageUpdatedInfo":"PageUpdatedInfo_pageUpdatedInfo__I5vDW"};